import React from 'react'
import Typography from '@mui/material/Typography';
import { createTheme, ThemeProvider, styled } from '@mui/material/styles';
import { makeStyles} from '@mui/styles';

export default function ZTypography(props) {
    const classes = useStyles();
    return (
        <div className={classes.root}>
            <Typography {...props}>
                {props.children}
            </Typography>
        </div>
    )
}

const useStyles = makeStyles((theme) => ({
    root: {
        
        '& > *': {
            margin: 4
        },

        '& p':{
            fontFamily: "Noto Sans ",
        }    
    }
}));